import { useEffect, useState, useCallback, useRef } from "react";
import axiosInstance from "services/AxiosInstance";

const API_URL = "/api/v3/zonas-sociales/activos/proveedores/";

export const useProveedoresMantenimiento = (filters = {}) => {
  const [proveedores, setProveedores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
  });

  // Use ref to avoid re-renders when filters object reference changes
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const fetchProveedores = useCallback(async (page = 1) => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams({ page, ...filtersRef.current });
      const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
      setProveedores(response.data.results || response.data);
      setPagination({
        count: response.data.count || 0,
        next: response.data.next || null,
        previous: response.data.previous || null,
      });
      setError(null);
    } catch (err) {
      setError(err);
      console.error("Error fetching proveedores:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProveedores();
  }, []);

  const createProveedor = async (data) => {
    const response = await axiosInstance.post(API_URL, data);
    await fetchProveedores();
    return response.data;
  };

  const updateProveedor = async (uuid, data) => {
    const response = await axiosInstance.patch(`${API_URL}${uuid}/`, data);
    await fetchProveedores();
    return response.data;
  };

  const deleteProveedor = async (uuid) => {
    await axiosInstance.delete(`${API_URL}${uuid}/`);
    await fetchProveedores();
  };

  return {
    proveedores,
    isLoading,
    error,
    pagination,
    fetchProveedores,
    createProveedor,
    updateProveedor,
    deleteProveedor,
  };
};
